import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  LayoutDashboard, Users, PawPrint, QrCode, MapPin, 
  Phone, ClipboardList, Store, Package, LogOut 
} from 'lucide-react';

const menuItems = [
  { to: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/admin/usuarios', icon: Users, label: 'Usuarios' },
  { to: '/admin/mascotas', icon: PawPrint, label: 'Mascotas' },
  { to: '/admin/codigos', icon: QrCode, label: 'Códigos QR' },
  { to: '/admin/ubicaciones', icon: MapPin, label: 'Ubicaciones' },
  { to: '/admin/contactos', icon: Phone, label: 'Contactos' },
  { to: '/admin/historial', icon: ClipboardList, label: 'Historial' },
  { to: '/admin/socios', icon: Store, label: 'Socios' },
  { to: '/admin/productos', icon: Package, label: 'Productos' },
];

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();

  return (
    <div className="sp-config" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <aside style={{
        width: 260,
        background: 'var(--sp-primary)',
        color: '#fff',
        padding: '1.5rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        position: 'sticky',
        top: 0,
        height: '100vh',
        overflowY: 'auto'
      }}>
        <h2 style={{ fontSize: '1.3rem', fontWeight: 800, marginBottom: '1.5rem', paddingLeft: '0.75rem' }}>
          SmartPet Admin
        </h2>
        <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', flex: 1 }}>
          {menuItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: '0.6rem',
                padding: '0.65rem 0.75rem',
                borderRadius: 'var(--sp-radius-sm)',
                color: '#fff',
                textDecoration: 'none',
                fontWeight: 700,
                fontSize: '0.92rem',
                background: isActive ? 'rgba(255,255,255,0.18)' : 'transparent',
                transition: 'background 0.2s'
              })}
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button
          onClick={logout}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.6rem',
            padding: '0.65rem 0.75rem',
            borderRadius: 'var(--sp-radius-sm)',
            background: 'rgba(255,255,255,0.1)',
            border: 'none',
            color: '#fff',
            fontWeight: 700,
            cursor: 'pointer',
            marginTop: 'auto'
          }}
        >
          <LogOut size={18} />
          Cerrar sesión
        </button>
      </aside>

      {/* Contenido principal */}
      <main style={{ flex: 1, padding: '1.5rem', background: 'var(--sp-bg)' }}>
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;